module.exports = __webpack_public_path__ + "img/emo_46.0bdadebb.png";